import { Icon } from 'gu-ui-kit'
import React from 'react'

export default () => {
  return {
    initial: {
      search: '',
      types: [],
      statuses: [],
    },
    configuration: {
      search: {
        subbutton: { isVisible: (value = '') => !!value },
        label: 'referral::payout_profiles.filters.dropdown.items.search.label',
        placeholder: 'referral::payout_profiles.filters.dropdown.items.search.placeholder',
        order: 1,
        type: 'input',
      },
      statuses: {
        subbutton: {
          isVisible: (value = [], breakpoints) => value.length > 0 || !breakpoints.fb,
        },
        icon: (
          <Icon
            name={'checkmark2'}
            size={'s'}
            bgColor={'Label-Confirm'}
            color={'Label-Onsurface'}
          />
        ),
        label: 'referral::payout_profiles.filters.dropdown.items.statuses.label',
        position: 'dropdown',
        type: 'checkbox group',
        optionLabelPrefix: 'referral::payout_profiles.statuses.',
        options: ['new', 'pending', 'approved', 'declined'],
      },
      types: {
        subbutton: {
          isVisible: (value = [], breakpoints) => value.length > 0 || !breakpoints.fb,
        },
        icon: (
          <Icon
            name={'checkmark2'}
            size={'s'}
            bgColor={'Accent-Notice-Primary'}
            color={'Label-Onsurface'}
          />
        ),
        label: 'referral::payout_profiles.filters.dropdown.items.types.label',
        position: 'dropdown',
        type: 'checkbox group',
        optionLabelPrefix: 'common::payout_types.',
        options: ['epayments', 'webmoney', 'capitalist'],
      },
    },
  }
}
